export default "__VITE_ASSET__Y802f0kD__"